var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"explore-loader-local"},[_c('div',{staticClass:"loader-content"},[_c('v-progress-circular',{staticClass:"loader-spinner",attrs:{"indeterminate":"","color":"#8e84c0","size":"50","width":"2"}},[_c('v-img',{staticClass:"loader-logo",attrs:{"src":_vm.Logo,"height":"28px","width":"28px"}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }